import { DocumentType } from '../gen/graphql';

export const TITLE_LIMIT_LENGTH = 50;

export const PLACEHOLDER_FOR_PC = '学びたいトピックを検索　例：Laravel、Webサイト制作、学習方法';
export const PLACEHOLDER_FOR_SP = '学びたいトピックを検索';
export const DEFAULT_SEARCH_TYPES = [DocumentType.Program, DocumentType.Practice];
